import React, { useState, useEffect } from 'react';
import { Typography, CircularProgress, Alert, Box } from '@mui/material';
import { buildApiUrl } from '../config/api';

const BrandsInfo = () => {
    const [brandsData, setBrandsData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBrands = async () => {
            try {
                setLoading(true);
                setError(null);
                
                const response = await fetch(buildApiUrl('api/brands'), {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                setBrandsData(data);
            } catch (err) {
                console.error('Error fetching brands:', err);
                setError('Failed to load brands information. Please try again later.');
            } finally {
                setLoading(false);
            }
        };

        fetchBrands();
    }, []);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                <CircularProgress size={24} />
            </Box>
        );
    }

    if (error) {
        return (
            <Alert severity="error" sx={{ mb: 2 }}>
                {error}
            </Alert>
        );
    }

    if (!brandsData) {
        return (
            <Typography className="faq-answer" paragraph>
                Unable to load brands information at this time.
            </Typography>
        );
    }

    const { brands, total_products, total_brands } = brandsData;

    return (
        <>
            <Typography className="faq-answer" paragraph>
                A total of <strong>{total_products.toLocaleString()}</strong> products are available across <strong>{total_brands}</strong> brands in our database.
            </Typography>
            <Typography className="faq-answer" paragraph>
                The following brands are currently available:
            </Typography>
            <Box sx={{ 
                display: 'flex', 
                flexWrap: 'wrap', 
                gap: 1, 
                mb: 2,
                maxHeight: '300px',
                overflowY: 'auto',
                p: 1,
                border: '1px solid #e0e0e0',
                borderRadius: 1,
                backgroundColor: '#fafafa'
            }}>
                {brands.map((brand, index) => (
                    <Typography 
                        key={index}
                        component="span"
                        sx={{
                            display: 'inline-block',
                            px: 1.5,
                            py: 0.5,
                            backgroundColor: '#e3f2fd',
                            color: '#1976d2',
                            borderRadius: 1,
                            fontSize: '0.875rem',
                            fontWeight: 500,
                            border: '1px solid #bbdefb'
                        }}
                    >
                        {brand}
                    </Typography>
                ))}
            </Box>
            <Typography className="faq-answer" paragraph>
                We're constantly adding new brands and products to our database. If you don't see a product or a brand you're interested in, please let us know by emailing us at{' '}
                <a href="mailto:meow@thepickykitty.com" style={{ color: '#1976d2', textDecoration: 'none' }}>
                    meow@thepickykitty.com
                </a>.
            </Typography>
        </>
    );
};

export default BrandsInfo;
